(function() {
	'use strict';

	var $ = avm.require('cash'),
		$tablesMore = $('.js-smb-tables-showMore');


	// Show hidden rows
	$tablesMore.on('click', function(e) {
		e.preventDefault();
		var $self = $(this),
            $table = $('.js-smb-tables'), 
			$tableRows = $table.find('.js-smb-tables-hidden');
		$self.hide();
		$tableRows.addClass('is-active');
	});

})();